import * as fromDatatype from '../datatype-library';

export interface bl_wf_md_transition_action_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  transition_guid: fromDatatype.GuidDataFieldInterface;
  action_guid: fromDatatype.GuidDataFieldInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.RevisionDataFieldInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  default_process_status_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_wf_md_transition_action_RowClass
  implements bl_wf_md_transition_action_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    transition_guid: fromDatatype.GuidDataFieldInterface;
    action_guid: fromDatatype.GuidDataFieldInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.RevisionDataFieldInterface;
    namespace: fromDatatype.NamespaceDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    default_process_status_guid: fromDatatype.GuidDataFieldInterface;
}
